<script lang="ts" generics="T">
  import { faSort } from '@itdev-fortawesome/pro-solid-svg-icons/faSort';
  import { FontAwesomeIcon } from '@fortawesome/svelte-fontawesome';
  import { faSortDesc } from '@itdev-fortawesome/pro-solid-svg-icons/faSortDesc';
  import { faSortAsc } from '@itdev-fortawesome/pro-solid-svg-icons/faSortAsc';

  interface Props {
    currentSort: T | null;
    currentSortOrder: 'asc' | 'desc' | null;
    sortColumnLabel: string;
    sortColumn: T;
    small?: boolean;
  }

  let {
    currentSort = $bindable(),
    currentSortOrder = $bindable(),
    sortColumnLabel,
    sortColumn,
    small = false,
  }: Props = $props();

  let icon = $derived.by(() => {
    if (currentSort !== sortColumn) {
      return faSort;
    } else if (currentSortOrder === 'asc') {
      return faSortAsc;
    }
    return faSortDesc;
  });

  let label = $derived.by(() => {
    if (currentSort !== sortColumn) {
      return `Click to sort by ${sortColumnLabel} ascending.`;
    } else if (currentSortOrder === 'asc') {
      return `Currently sorting by ${sortColumnLabel} descending. Click to sort descending`;
    }
    return `Currently sorting by ${sortColumnLabel} descending. Click to sort ascending.`;
  });

  function click() {
    if (currentSort !== sortColumn) {
      currentSort = sortColumn;
      currentSortOrder = 'asc';
    } else if (currentSortOrder === 'asc') {
      currentSortOrder = 'desc';
    } else {
      currentSortOrder = 'asc';
    }
  }
</script>

<button class="btn sort-button" onclick={click}>
  <span class="visually-hidden">{label}</span>
  {#key icon}
    <FontAwesomeIcon {icon} size={small ? 'xs' : undefined} />
  {/key}
</button>

<style>
  .sort-button {
    color: var(--bs-secondary);
    --bs-btn-padding-y: 0;
    --bs-btn-padding-x: 0;
    --bs-btn-active-border-color: transparent;
    --bs-btn-active-color: var(--bs-tertiary);
  }

  .sort-button:hover {
    color: black;
  }
</style>
